let suppressUnauthorizedRedirectToast = false;

/** Call before clearing tokens during an intentional sign-out. */
export function suppressNextUnauthorizedRedirectToast() {
	suppressUnauthorizedRedirectToast = true;
}

export function consumeUnauthorizedRedirectToastSuppression(): boolean {
	const suppress = suppressUnauthorizedRedirectToast;
	suppressUnauthorizedRedirectToast = false;
	return suppress;
}
